var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#heart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#014583",
    d: "M5.56 12.05c-1.923-1.25-1.8-4.752.281-7.822S11.166-.298 13.088.951s1.799 4.751-.282 7.82-5.325 4.544-7.247 3.278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005098",
    d: "M8.767 11.997c1.569-1.231 1.216-4.266-.811-6.78S3 1.662 1.432 2.876c-1.57 1.231-1.217 4.266.81 6.78s4.955 3.555 6.525 2.341"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "heart_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.445.5h14v12h-14z"
  })))));
};
export default SvgHeart;